export function getClientAppNavUrl(tagId: string): string {
  return `${import.meta.env.VITE_CLIENT_APP_URL}/nav/${tagId}`;
}

export function getClientAppComplianceMatrixUrl(complianceId?: string): string {
  const baseUrl = `${import.meta.env.VITE_CLIENT_APP_URL}/compliance-matrix`;

  if (!complianceId) {
    return baseUrl;
  }

  return `${baseUrl}?compliance=${encodeURIComponent(complianceId)}`;
}
